import { createInteraction } from './backendApi';
import { getApplaussAuth } from './authManager';

/**
 * Record a one-shot event interaction (buy_ticket, add_to_calendar, …): a signed-in
 * reader through POST /interactions, anyone else through the anonymous tracker, which
 * drops it unless the visitor consented. Never rejects: an interaction that fails to save
 * must not stop the action the reader asked for.
 *
 * Returns the request's promise when there is a request, nothing on the anonymous path.
 * Callers that open a window do it before calling this, inside the click.
 * @param {string} eventId
 * @param {string} interactionType - one of the API's BaseInteractionType values
 * @param {(eventId: string) => void} trackAnonymously - the anonymousTracker function for it
 * @returns {Promise<void>|undefined}
 */
export function recordEventInteraction(eventId, interactionType, trackAnonymously) {
  if (!eventId) return undefined;
  const auth = getApplaussAuth();
  if (auth && !auth.isExpired) {
    return createInteraction(eventId, interactionType).then(
      () => undefined,
      (error) => {
        console.error(`Failed to save ${interactionType} interaction:`, error);
      },
    );
  }
  trackAnonymously(eventId);
  return undefined;
}
